import type { IStockRepository, AssetCreateInput } from '@/features/stock/domain/repositories/IStockRepository.js';
import type { StockAssetEntity } from '@/features/stock/domain/entities/StockEntity.js';

interface Deps { stockRepository: IStockRepository; }

export function createCreateAssetUseCase({ stockRepository }: Deps) {
  return async function createAsset(input: AssetCreateInput): Promise<StockAssetEntity> {
    return stockRepository.createAsset(input);
  };
}
